import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import './sentry'; // Import Sentry for global error tracking
import { PublicClientApplication } from '@azure/msal-browser'
import { BrowserRouter,  } from "react-router";
import { initializeMsal, msalConfig } from './lib/msal-config.ts'
import { MsalProvider } from '@azure/msal-react'
import * as Sentry from '@sentry/react';

// const clientId = import.meta.env.VITE_AZURE_CLIENT_ID
// const authority = import.meta.env.VITE_AZURE_AUTHORITY

// const msalConfiguration = {
//   auth: {
//     clientId: clientId,
//     authority: authority,
//     redirectUri: "/",
//     postLogoutRedirectUri: "/"
//   }
// }
export const msalInstance = new PublicClientApplication(msalConfig);
        // const response = await msalInstance.ssoSilent({
        //     scopes: ["https://btdevtenant.onmicrosoft.com/bgapi/Data.Read"], 
        // });
        // console.log(response.accessToken)



// Account selection logic is app dependent. Adjust as needed for different use cases.
// const accounts = msalInstance.getAllAccounts();
// console.log({ accounts, msalInstance });
// if (accounts.length > 0) {
//   msalInstance.setActiveAccount(accounts[0]);
// }

// msalInstance.addEventCallback((event: EventMessage) => {
//   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
//     const payload = event.payload as AuthenticationResult;
//     const account = payload.account;
//     msalInstance.setActiveAccount(account);
//   }
// });

(async () => {
  await initializeMsal();

  const container = document.getElementById("root")!;
  const root = createRoot(container, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
  });

  root.render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </StrictMode>
  );
})();
